import {useParams} from 'react-router-dom'
import React from 'react';

import {SJReviewTerrainCom} from '../containers'
function SJReviewTerrainComPage() {
    console.log('shsohourn to star')
    let { id } = useParams();
    let svparams = { 'id': id}
    console.log('shsohourn to svparams 3', svparams)
    return (
        <SJReviewTerrainCom svparams= {svparams} />
    );
}
export default SJReviewTerrainComPage

/*
import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {SVReviewTerrainCom} from '../containers'
function SJReviewTerrainComPage() {
    let { id } = useParams();
    let svparams = { 'id': id}
    return (
        <div>

        <p>
          SV SojournReviewContainerPage Component
        </p>
        <SVReviewTerrainCom svparams= {svparams} />
        </div>
    );
}
export default SJReviewTerrainComPage
*/